export const orderStatus = [
  { label: "All", value: null },
  { label: "Abandoned cart", value: "PLACED" },
  { label: "In Progress", value: "IN_PROGRESS" },
  { label: "Pending", value: "PENDING" },
  { label: "Completed", value: "COMPLETED" },
  { label: "Shipped", value: "SHIPPED" },
  { label: "Delivered", value: "DELIVERED" },
  { label: "Returned", value: "RETURNED" },
  { label: "Canceled", value: "CANCELED" },
];

export const returnOrderStatus = [
  { label: "Return Status", value: null },
  { label: "Full  Return", value: "FULL_RETURN" },
  { label: "Partial Return", value: "PARTIAL_RETURN" },
  { label: "No Return", value: "NO_RETURN" },
];
